export class MissingDayOfWeekError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'MissingDayOfWeekError'
  }
}
